import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import SocialCompanyListItemCompanyShort from "./SocialCompanyListItemCompanyShort";
import SocialCompanyListItemPeopleLinkShort from "./SocialCompanyListItemPeopleLinkShort";
import SocialCompanyListItemPeopleShort from "./SocialCompanyListItemPeopleShort";
import { useAllCompanyWeight } from "./apiCompanyWeight";
import ListShort from "components/ui/atoms/ListShort";
import { useCompanyPeople } from "models/companies/apiCompany";
import { useAllPeopleCompanyWeight } from "models/social/apiPeopleCompanyWeight";

const defaultState = {
  same_company: true,
  people__in_team: 0,
  ordering: "-people__link_strength_with_team",
  offset: 0,
};

const SocialTabList = ({ activeTab, handleChange }) => {
  return (
    <TabContext value={activeTab}>
      <TabList onChange={handleChange} variant="scrollable" ringstyle="ringapp">
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              People
            </Typography>
          }
          value="People"
          wrapped
        />
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              Ring link
            </Typography>
          }
          value="Ring link"
          wrapped
        />
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              Company link
            </Typography>
          }
          value="Company link"
          wrapped
        />
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              People link
            </Typography>
          }
          value="People link"
          wrapped
        />
      </TabList>
    </TabContext>
  );
};

const SocialCompanyWidget = ({ companyId }) => {
  const [activeTab, setActiveTab] = useState("People");
  const [resource, setResource] = useState(null);
  const [resourceStatus, setResourceStatus] = useState(null);
  const [state, setState] = useState(defaultState);
  const [fetchParams, setFetchParams] = useState(null);
  const { data: peopleCompanyWeight, status: peopleCompanyWeightStatus } =
    useAllPeopleCompanyWeight(fetchParams);
  const { data: companyWeight, status: companyWeightStatus } =
    useAllCompanyWeight(fetchParams);
  const { data: people, status: peopleStatus } = useCompanyPeople(companyId);

  useEffect(() => {
    setFetchParams({
      company: [companyId],
      ...state,
    });
  }, [companyId, state]);

  useEffect(() => {
    switch (activeTab) {
      case "People":
        break;
      case "Ring link":
        setState({
          ...state,
          same_company: false,
          people__in_team: 1,
          offset: 0,
          ordering: "-weight",
        });
        break;
      case "Company link":
        setState({
          ...state,
          same_company: false,
          people__in_team: 0,
          offset: 0,
          ordering: "-weight",
        });
        break;
      case "People link":
        setState({
          ...state,
          same_company: false,
          people__in_team: 0,
          offset: 0,
          ordering: "-weight",
        });
        break;
      default:
        throw new Error("Unknown tab");
    }
  }, [activeTab]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <ListShort
      title="Socials"
      resource={
        activeTab === "People"
          ? people
          : activeTab === "Company link"
          ? companyWeight
          : peopleCompanyWeight
      }
      resourceStatus={
        activeTab === "People"
          ? peopleStatus
          : activeTab === "Company link"
          ? companyWeightStatus
          : peopleCompanyWeightStatus
      }
      state={state}
      setState={setState}
      TabList={
        <SocialTabList activeTab={activeTab} handleChange={handleChange} />
      }
      ListItemComponent={
        activeTab === "People"
          ? SocialCompanyListItemPeopleShort
          : activeTab === "Company link"
          ? SocialCompanyListItemCompanyShort
          : SocialCompanyListItemPeopleLinkShort
      }
      emptyMessage="No socials"
      listItemComponentProps={{
        ratingKey:
          activeTab === "People" ? "link_strength_with_team" : "weight",
      }}
      pagination
    />
  );
};

export default SocialCompanyWidget;
